<template>
  <div class="row">
    <div class="col-12">
      <special-issue-form
        :special-issue="initialEnterpriseData"
      />
      <!-- <div class="col-12 text-center mt-5">
        <button-wrapper @click.prevent="submitSpecialIssue">
          修改
        </button-wrapper>
      </div> -->
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
// import { validationMixin } from 'vuelidate'
import ButtonWrapper from '~components/common/buttons'
import SpecialIssueForm from '../common/SpecialIssueForm'
// import { specialIssueValidations } from './enrollment-process-validations'
export default {
  name: 'EnterpriseSpecialIssue',
  components: {
    ButtonWrapper,
    SpecialIssueForm
  },
  // mixins: [validationMixin],
  data () {
    return {
      initialEnterpriseData: {},
      currentEnterpriseData: {}
    }
  },
  computed: {
    ...mapGetters('pages/enterprises', [
      // 'currentEnterpriseSpecialIssueGetter',
      'currentEnterpriseGetter'
    ])
  },
  watch: {
    // currentEnterpriseSpecialIssueGetter (value) {
    //   this.initialEnterpriseData = Object.assign({}, this.initialEnterpriseData, value)
    // },
    currentEnterpriseGetter (value) {
      this.initialEnterpriseData = Object.assign({}, this.initialEnterpriseData, value)
    }
  },
  // validations: specialIssueValidations,
  created () {
    if (Object.keys(this.currentEnterpriseGetter).length > 0) {
      this.initialEnterpriseData = Object.assign({}, this.initialEnterpriseData, this.currentEnterpriseGetter)
    }
    // if (Object.keys(this.currentEnterpriseSpecialIssueGetter).length > 0) {
    //   this.initialEnterpriseData = Object.assign({}, this.initialEnterpriseData, this.currentEnterpriseSpecialIssueGetter)
    // }
  },
  methods: {
    // ...mapActions('pages/enterprises', [
    //   'modifyOrderById'
    // ]),
    // submitSpecialIssue () {
    //   this.$v.currentEnterpriseData.$touch()
    //   if (!this.$v.$invalid) {
    //     this.modifyOrderById({
    //       campus_recruitment_id: this.$route.params.id,
    //       specialIssue: this.currentEnterpriseData
    //     })
    //   }
    // }
  }
}
</script>
